import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Attribute } from '../entities/schema/attribute.entity';
import { MaingroupAttribute } from '../entities/schema/maingroupattribute.entity';
import { Maingroup } from '../entities/schema/maingroup.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class MaingroupAttributeService extends ODataEntityService<MaingroupAttribute> {
  constructor(protected client: ODataClient) {
    super(client, 'MaingroupAttribute', 'entities.schema.MaingroupAttribute');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public attribute(entity: EntityKey<MaingroupAttribute>): ODataNavigationPropertyResource<Attribute> {
    return this.entity(entity).navigationProperty<Attribute>('attribute');
  }
  public maingroup(entity: EntityKey<MaingroupAttribute>): ODataNavigationPropertyResource<Maingroup> {
    return this.entity(entity).navigationProperty<Maingroup>('maingroup');
  }
  public status(entity: EntityKey<MaingroupAttribute>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<MaingroupAttribute>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
